import type { CurrencyType } from '@dealstack/prisma-client';

//TODO REFACTOR this must be deleted and used CurrencyType instead - D.Zghinnik
export const CURRENCY: Record<CurrencyType, CurrencyType> = Object.freeze({
	EUR: 'EUR',
	GBP: 'GBP',
	USD: 'USD',
	CHF: 'CHF',
	DKK: 'DKK',
	NOK: 'NOK',
	PLN: 'PLN',
	SEK: 'SEK',
	DZD: 'DZD',
	ARS: 'ARS',
	AMD: 'AMD',
	AWG: 'AWG',
	AUD: 'AUD',
	AZN: 'AZN',
	BSD: 'BSD',
	BHD: 'BHD',
	THB: 'THB',
	PAB: 'PAB',
	BBD: 'BBD',
	BYN: 'BYN',
	BZD: 'BZD',
	BMD: 'BMD',
	VES: 'VES',
	VED: 'VED',
	BOB: 'BOB',
	BRL: 'BRL',
	BND: 'BND',
	BGN: 'BGN',
	BIF: 'BIF',
	CVE: 'CVE',
	CAD: 'CAD',
	KYD: 'KYD',
	XOF: 'XOF',
	XAF: 'XAF',
	XPF: 'XPF',
	CLP: 'CLP',
	COP: 'COP',
	KMF: 'KMF',
	CDF: 'CDF',
	BAM: 'BAM',
	NIO: 'NIO',
	CRC: 'CRC',
	CUP: 'CUP',
	CZK: 'CZK',
	GMD: 'GMD',
	MKD: 'MKD',
	DJF: 'DJF',
	STN: 'STN',
	DOP: 'DOP',
	VND: 'VND',
	XCD: 'XCD',
	EGP: 'EGP',
	SVC: 'SVC',
	ETB: 'ETB',
	FKP: 'FKP',
	FJD: 'FJD',
	HUF: 'HUF',
	GHS: 'GHS',
	GIP: 'GIP',
	HTG: 'HTG',
	PYG: 'PYG',
	GNF: 'GNF',
	GYD: 'GYD',
	HKD: 'HKD',
	UAH: 'UAH',
	ISK: 'ISK',
	INR: 'INR',
	IRR: 'IRR',
	IQD: 'IQD',
	JMD: 'JMD',
	JOD: 'JOD',
	KES: 'KES',
	PGK: 'PGK',
	KWD: 'KWD',
	AOA: 'AOA',
	MMK: 'MMK',
	LAK: 'LAK',
	GEL: 'GEL',
	LBP: 'LBP',
	ALL: 'ALL',
	HNL: 'HNL',
	SLE: 'SLE',
	LRD: 'LRD',
	LYD: 'LYD',
	SZL: 'SZL',
	LSL: 'LSL',
	MGA: 'MGA',
	MWK: 'MWK',
	MYR: 'MYR',
	MUR: 'MUR',
	MXN: 'MXN',
	MDL: 'MDL',
	MAD: 'MAD',
	MZN: 'MZN',
	NGN: 'NGN',
	ERN: 'ERN',
	NAD: 'NAD',
	NPR: 'NPR',
	ANG: 'ANG',
	ILS: 'ILS',
	TWD: 'TWD',
	NZD: 'NZD',
	BTN: 'BTN',
	KPW: 'KPW',
	MRU: 'MRU',
	TOP: 'TOP',
	PKR: 'PKR',
	MOP: 'MOP',
	CUC: 'CUC',
	UYU: 'UYU',
	PHP: 'PHP',
	BWP: 'BWP',
	QAR: 'QAR',
	GTQ: 'GTQ',
	ZAR: 'ZAR',
	OMR: 'OMR',
	KHR: 'KHR',
	RON: 'RON',
	MVR: 'MVR',
	IDR: 'IDR',
	RUB: 'RUB',
	RWF: 'RWF',
	SHP: 'SHP',
	SAR: 'SAR',
	RSD: 'RSD',
	SCR: 'SCR',
	SGD: 'SGD',
	PEN: 'PEN',
	SBD: 'SBD',
	KGS: 'KGS',
	SOS: 'SOS',
	TJS: 'TJS',
	SSP: 'SSP',
	LKR: 'LKR',
	XSU: 'XSU',
	SDG: 'SDG',
	SRD: 'SRD',
	SYP: 'SYP',
	BDT: 'BDT',
	WST: 'WST',
	TZS: 'TZS',
	KZT: 'KZT',
	TTD: 'TTD',
	MNT: 'MNT',
	TND: 'TND',
	TRY: 'TRY',
	TMT: 'TMT',
	AED: 'AED',
	UGX: 'UGX',
	UZS: 'UZS',
	VUV: 'VUV',
	KRW: 'KRW',
	YER: 'YER',
	JPY: 'JPY',
	CNY: 'CNY',
	ZMW: 'ZMW',
	ZWL: 'ZWL',
});

export const CURRENCY_SYMBOLS: Record<CurrencyType, string> = Object.freeze({
	USD: '$',
	EUR: '€',
	GBP: '£',
	PLN: 'ZŁ',
	DKK: 'DKK',
	NOK: 'NOK',
	SEK: 'SEK',
	CHF: 'CHF',
	DZD: 'د.ج',
	ARS: '$',
	AMD: '֏',
	AWG: 'ƒ',
	AUD: 'A$',
	AZN: '₼',
	BSD: '$',
	BHD: '.د.ب',
	THB: '฿',
	PAB: 'B/.',
	BBD: '$',
	BYN: 'Br',
	BZD: '$',
	BMD: '$',
	VES: 'Bs.',
	VED: 'Bs.',
	BOB: 'Bs.',
	BRL: 'R$',
	BND: '$',
	BGN: 'лв.',
	BIF: 'FBu',
	CVE: '$',
	CAD: 'C$',
	KYD: '$',
	XOF: 'CFA',
	XAF: 'FCFA',
	XPF: '₣',
	CLP: '$',
	COP: '$',
	KMF: 'CF',
	CDF: 'FC',
	BAM: 'KM',
	NIO: 'C$',
	CRC: '₡',
	CUP: '$',
	CZK: 'Kč',
	GMD: 'D',
	MKD: 'ден',
	DJF: 'Fdj',
	STN: 'Db',
	DOP: '$',
	VND: '₫',
	XCD: '$',
	EGP: '£',
	SVC: '$',
	ETB: 'Br',
	FKP: '£',
	FJD: '$',
	HUF: 'Ft',
	GHS: 'GH₵',
	GIP: '£',
	HTG: 'G',
	PYG: '₲',
	GNF: 'FG',
	GYD: '$',
	HKD: 'HK$',
	UAH: '₴',
	ISK: 'kr',
	INR: '₹',
	IRR: '﷼',
	IQD: 'ع.د',
	JMD: '$',
	JOD: 'د.ا',
	KES: 'KSh',
	PGK: 'K',
	KWD: 'د.ك',
	AOA: 'Kz',
	MMK: 'Ks',
	LAK: '₭',
	GEL: '₾',
	LBP: 'ل.ل',
	ALL: 'L',
	HNL: 'L',
	SLE: 'Le',
	LRD: '$',
	LYD: 'ل.د',
	SZL: 'E',
	LSL: 'L',
	MGA: 'Ar',
	MWK: 'MK',
	MYR: 'RM',
	MUR: '₨',
	MXN: '$',
	MDL: 'L',
	MAD: 'د.م.',
	MZN: 'MT',
	NGN: '₦',
	ERN: 'Nfk',
	NAD: '$',
	NPR: '₨',
	ANG: 'ƒ',
	ILS: '₪',
	TWD: 'NT$',
	NZD: '$',
	BTN: 'Nu.',
	KPW: '₩',
	MRU: 'UM',
	TOP: 'T$',
	PKR: '₨',
	MOP: 'P',
	CUC: '$',
	UYU: '$U',
	PHP: '₱',
	BWP: 'P',
	QAR: 'ر.ق',
	GTQ: 'Q',
	ZAR: 'R',
	OMR: 'ر.ع.',
	KHR: '៛',
	RON: 'lei',
	MVR: 'Rf',
	IDR: 'Rp',
	RUB: '₽',
	RWF: 'FRw',
	SHP: '£',
	SAR: 'ر.س',
	RSD: 'дин.',
	SCR: '₨',
	SGD: 'S$',
	PEN: 'S/',
	SBD: '$',
	KGS: 'лв',
	SOS: 'Sh',
	TJS: 'ЅM',
	SSP: '£',
	LKR: 'Rs',
	XSU: 'Sucre',
	SDG: 'ج.س.',
	SRD: '$',
	SYP: '£',
	BDT: '৳',
	WST: 'T',
	TZS: 'TSh',
	KZT: '₸',
	TTD: '$',
	MNT: '₮',
	TND: 'د.ت',
	TRY: '₺',
	TMT: 'm',
	AED: 'د.إ',
	UGX: 'USh',
	UZS: 'сўм',
	VUV: 'Vt',
	KRW: '₩',
	YER: '﷼',
	JPY: '¥',
	CNY: '¥',
	ZMW: 'ZK',
	ZWL: '$',
});

export const convertCurrencyToSymbol = (currency?: CurrencyType): string => {
	return currency ? CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS[CURRENCY.EUR] : '';
};

export function format(value: number | string, currency?: CurrencyType): string {
	const parsedValue = `${value}`;

	return parsedValue + currency;
}

export const CURRENCY_OPTIONS = Object.values(CURRENCY).map((currency) => ({
	value: currency,
	label: currency,
}));

// List generated by AI - we need to verify it before going to prod
export const CURRENCY_TO_COUNTRY_CODE: Record<CurrencyType, string> = Object.freeze({
	EUR: 'EU', // European Union
	GBP: 'GB', // United Kingdom
	USD: 'US', // United States
	CHF: 'CH', // Switzerland
	DKK: 'DK', // Denmark
	NOK: 'NO', // Norway
	PLN: 'PL', // Poland
	SEK: 'SE', // Sweden
	DZD: 'DZ', // Algeria
	ARS: 'AR', // Argentina
	AMD: 'AM', // Armenia
	AWG: 'AW', // Aruba
	AUD: 'AU', // Australia
	AZN: 'AZ', // Azerbaijan
	BSD: 'BS', // Bahamas
	BHD: 'BH', // Bahrain
	THB: 'TH', // Thailand
	PAB: 'PA', // Panama
	BBD: 'BB', // Barbados
	BYN: 'BY', // Belarus
	BZD: 'BZ', // Belize
	BMD: 'BM', // Bermuda
	VES: 'VE', // Venezuela
	VED: 'VE', // Venezuela
	BOB: 'BO', // Bolivia
	BRL: 'BR', // Brazil
	BND: 'BN', // Brunei
	BGN: 'BG', // Bulgaria
	BIF: 'BI', // Burundi
	CVE: 'CV', // Cape Verde
	CAD: 'CA', // Canada
	KYD: 'KY', // Cayman Islands
	XOF: 'SN', // CFA Franc BCEAO (using Senegal as primary)
	XAF: 'CM', // CFA Franc BEAC (using Cameroon as primary)
	XPF: 'PF', // CFP Franc (French Polynesia)
	CLP: 'CL', // Chile
	COP: 'CO', // Colombia
	KMF: 'KM', // Comoros
	CDF: 'CD', // Congo
	BAM: 'BA', // Bosnia and Herzegovina
	NIO: 'NI', // Nicaragua
	CRC: 'CR', // Costa Rica
	CUP: 'CU', // Cuba
	CZK: 'CZ', // Czech Republic
	GMD: 'GM', // Gambia
	MKD: 'MK', // North Macedonia
	DJF: 'DJ', // Djibouti
	STN: 'ST', // São Tomé and Príncipe
	DOP: 'DO', // Dominican Republic
	VND: 'VN', // Vietnam
	XCD: 'AG', // East Caribbean Dollar (using Antigua and Barbuda as primary)
	EGP: 'EG', // Egypt
	SVC: 'SV', // El Salvador
	ETB: 'ET', // Ethiopia
	FKP: 'FK', // Falkland Islands
	FJD: 'FJ', // Fiji
	HUF: 'HU', // Hungary
	GHS: 'GH', // Ghana
	GIP: 'GI', // Gibraltar
	HTG: 'HT', // Haiti
	PYG: 'PY', // Paraguay
	GNF: 'GN', // Guinea
	GYD: 'GY', // Guyana
	HKD: 'HK', // Hong Kong
	UAH: 'UA', // Ukraine
	ISK: 'IS', // Iceland
	INR: 'IN', // India
	IRR: 'IR', // Iran
	IQD: 'IQ', // Iraq
	JMD: 'JM', // Jamaica
	JOD: 'JO', // Jordan
	KES: 'KE', // Kenya
	PGK: 'PG', // Papua New Guinea
	KWD: 'KW', // Kuwait
	AOA: 'AO', // Angola
	MMK: 'MM', // Myanmar
	LAK: 'LA', // Laos
	GEL: 'GE', // Georgia
	LBP: 'LB', // Lebanon
	ALL: 'AL', // Albania
	HNL: 'HN', // Honduras
	SLE: 'SL', // Sierra Leone
	LRD: 'LR', // Liberia
	LYD: 'LY', // Libya
	SZL: 'SZ', // Eswatini
	LSL: 'LS', // Lesotho
	MGA: 'MG', // Madagascar
	MWK: 'MW', // Malawi
	MYR: 'MY', // Malaysia
	MUR: 'MU', // Mauritius
	MXN: 'MX', // Mexico
	MDL: 'MD', // Moldova
	MAD: 'MA', // Morocco
	MZN: 'MZ', // Mozambique
	NGN: 'NG', // Nigeria
	ERN: 'ER', // Eritrea
	NAD: 'NA', // Namibia
	NPR: 'NP', // Nepal
	ANG: 'CW', // Netherlands Antillean Guilder (using Curaçao as primary)
	ILS: 'IL', // Israel
	TWD: 'TW', // Taiwan
	NZD: 'NZ', // New Zealand
	BTN: 'BT', // Bhutan
	KPW: 'KP', // North Korea
	MRU: 'MR', // Mauritania
	TOP: 'TO', // Tonga
	PKR: 'PK', // Pakistan
	MOP: 'MO', // Macau
	CUC: 'CU', // Cuba
	UYU: 'UY', // Uruguay
	PHP: 'PH', // Philippines
	BWP: 'BW', // Botswana
	QAR: 'QA', // Qatar
	GTQ: 'GT', // Guatemala
	ZAR: 'ZA', // South Africa
	OMR: 'OM', // Oman
	KHR: 'KH', // Cambodia
	RON: 'RO', // Romania
	MVR: 'MV', // Maldives
	IDR: 'ID', // Indonesia
	RUB: 'RU', // Russia
	RWF: 'RW', // Rwanda
	SHP: 'SH', // Saint Helena
	SAR: 'SA', // Saudi Arabia
	RSD: 'RS', // Serbia
	SCR: 'SC', // Seychelles
	SGD: 'SG', // Singapore
	PEN: 'PE', // Peru
	SBD: 'SB', // Solomon Islands
	KGS: 'KG', // Kyrgyzstan
	SOS: 'SO', // Somalia
	TJS: 'TJ', // Tajikistan
	SSP: 'SS', // South Sudan
	LKR: 'LK', // Sri Lanka
	XSU: 'PE', // SUCRE (using Peru as primary)
	SDG: 'SD', // Sudan
	SRD: 'SR', // Suriname
	SYP: 'SY', // Syria
	BDT: 'BD', // Bangladesh
	WST: 'WS', // Samoa
	TZS: 'TZ', // Tanzania
	KZT: 'KZ', // Kazakhstan
	TTD: 'TT', // Trinidad and Tobago
	MNT: 'MN', // Mongolia
	TND: 'TN', // Tunisia
	TRY: 'TR', // Turkey
	TMT: 'TM', // Turkmenistan
	AED: 'AE', // United Arab Emirates
	UGX: 'UG', // Uganda
	UZS: 'UZ', // Uzbekistan
	VUV: 'VU', // Vanuatu
	KRW: 'KR', // South Korea
	YER: 'YE', // Yemen
	JPY: 'JP', // Japan
	CNY: 'CN', // China
	ZMW: 'ZM', // Zambia
	ZWL: 'ZW', // Zimbabwe
});

export const getCurrencyCountryCode = (currency?: CurrencyType): string | null => {
	if (!currency) {
		return null;
	}
	return CURRENCY_TO_COUNTRY_CODE[currency] || null;
};

export const formatCurrency = (currency?: keyof typeof CURRENCY_SYMBOLS) => {
	if (!currency) {
		return '\u2013'; // en dash
	}

	const symbol = CURRENCY_SYMBOLS[currency];

	if (symbol) {
		return `${currency} (${symbol})`;
	}

	return currency;
};
